export default class LocationFilter{

	constructor(location, radius) {
		this.location = location;
		this.radius = radius;
	}
}
